export function getChannelMappingFilters (channelMappings) {
  let cognosChannelTypeOptions = new Set();
  let cognosChannelOptions = new Set();
  let cognosParentChannelOptions = new Set();
  let hcpMerchantChannelOptions = new Set();
  let marketplaceIdOptions = new Set();
  let marketplaceNameOptions = new Set();
  if (channelMappings) {
    channelMappings.forEach(channelMapping => {
      if (channelMapping.cognosChannelType) {
        cognosChannelTypeOptions.add(channelMapping.cognosChannelType);
      }
      if (channelMapping.cognosChannel) {
        cognosChannelOptions.add(channelMapping.cognosChannel);
      }
      if (channelMapping.cognosParentChannel) {
        cognosParentChannelOptions.add(channelMapping.cognosParentChannel);
      }
      if (channelMapping.hcpMerchantChannel) {
        hcpMerchantChannelOptions.add(channelMapping.hcpMerchantChannel);
      }
      if (channelMapping.marketplaceId) {
        marketplaceIdOptions.add(channelMapping.marketplaceId);
      }
      if (channelMapping.marketplaceName) {
        marketplaceNameOptions.add(channelMapping.marketplaceName);
      }
    });
  }
  return [
    {
      groupValuesLabel: 'Cognos Channel Type Values',
      propertyKey: 'cognosChannelType',
      propertyLabel: 'Cognos Channel Type',
      values: Array.from(cognosChannelTypeOptions),
    },
    {
      groupValuesLabel: 'Cognos Channel Values',
      propertyKey: 'cognosChannel',
      propertyLabel: 'Cognos Channel',
      values: Array.from(cognosChannelOptions),
    },
    {
      groupValuesLabel: 'Cognos Parent Channel Values',
      propertyKey: 'cognosParentChannel',
      propertyLabel: 'Cognos Parent Channel',
      values: Array.from(cognosParentChannelOptions),
    },
    {
      groupValuesLabel: 'HCP Merchant Channel Values',
      propertyKey: 'hcpMerchantChannel',
      propertyLabel: 'HCP Merchant Channel',
      values: Array.from(hcpMerchantChannelOptions),
    },
    {
      groupValuesLabel: 'Marketplace Id Values',
      propertyKey: 'marketplaceId',
      propertyLabel: 'Marketplace Id',
      values: Array.from(marketplaceIdOptions),
    },
    {
      groupValuesLabel: 'Marketplace Name Values',
      propertyKey: 'marketplaceName',
      propertyLabel: 'Marketplace Name',
      values: Array.from(marketplaceNameOptions),
    },
  ];
}



// WEBPACK FOOTER //
// ./src/components/config_central/channel_mapping/channel_mapping_utils.jsx